'use strict';

// ⚠ .cjs 는 webpack 이 babel 없이 직접 파싱한다 → `??` / `?.` 금지 (production 빌드가 깨진다). 기존 .cjs 헬퍼들과 같은 제약.

// 점수 산출(v2 scoring, v3 summary·export, EV_COUNT 보고서)은 한 문항 안 평가요소의 해당없음 값이 섞이면
// 422 { details: { error_type: 'data_integrity_error', affected_items: [...] } } 로 멈춘다 (backend #1986·#1991).
// 응답자 답과 평가자 판정의 시점이 어긋난 정상 상황이라 자동으로 맞추지 않는다 → 화면은 어느 문항이 막혔는지만 알린다.
// 무결성 422 가 아니면 null.
function integrityIssues(error) {
    const res = error && error.response;
    const details = res && res.status === 422 && res.data && res.data.details;
    if (!details || details.error_type !== 'data_integrity_error') return null;
    return Array.isArray(details.affected_items) ? details.affected_items : [];
}

const MAX_LINES = 20;

// alert 용 한 줄씩. 프로젝트 전체 export 는 업체 수만큼 길어질 수 있어 앞 20건만 보이고 나머지는 건수로.
function integrityIssueLines(items) {
    const lines = items.slice(0, MAX_LINES).map(item =>
        [item.company_name, item.label, item.sub_code && `(${item.sub_code})`].filter(Boolean).join(' '));
    if (items.length > MAX_LINES) lines.push(`외 ${items.length - MAX_LINES}건`);
    return lines;
}

// 막힌 문항의 평가 화면 라우트. query 는 CampaignReport_v2.goCompanyAnswers 와 같은 형식이고
// client(프로젝트 모드)·campaign_name(캠페인 모드)은 지금 화면 query 를 그대로 넘긴다 (없는 키는 router 가 뺀다).
// question_code 는 backend 가 함께 보낼 때만 붙는다 — 없으면 업체 평가 화면까지만 연다(그 화면 위에 막힌 문항 목록이 있다).
function integrityIssueRoute(issue, ctx) {
    const query = {
        client: ctx.client,
        campaign_name: ctx.campaign_name,
        pc: ctx.project_code,
        cmp: issue.campaign_id,
        cpn: issue.company_id,
        cpnm: issue.company_name,
        template_code: ctx.template_code,
        admin_mode: ctx.admin_mode,
    };
    if (issue.question_code) query.question_code = issue.question_code;
    return { name: 'CompanyAnswers', params: { company_id: issue.company_id }, query };
}

module.exports = { integrityIssues, integrityIssueLines, integrityIssueRoute };
